import React from 'react';
import './Styles/Modal.css';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    header?: React.ReactNode;
    children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ open, onClose, header, children }) => {
    return (
        <div className={`modal-overlay${open ? ' modal-overlay--visible' : ''}`}>
            <div className='modal'>
                <div className='modal__header-row'>
                    {header && <div className='modal__header'>{header}</div>}
                    <button className='modal__close-btn' onClick={onClose}>
                        &times;
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
};

export default Modal;
